import React, { Component } from 'react'
import axios from 'axios'
import Expense from './Expense'
import AddExpense from './AddExpense'
import { getAmount } from '../../Services/util-functions'
import { backendUrl } from '../../Services/backend-url'
import Button from '../Design/Button'

export default class ExpensesList extends Component {
  state = {
    expenses: this.props.user.expenses,
    username: this.props.user.username,
    activeExpense: {},
    expenseIndex: -1,
    addExpense: false
  }

  handleExpenseSelect = (expense, i) => {
    this.setState({
      activeExpense: expense,
      activeExpenseIndex: i,
    })
  }

  handleExpenseClosed = () => {
    this.setState({
      activeExpense: {},
      activeExpenseIndex: -1,
    })
  }

  handleAddExpense = () => {
    this.setState({ addExpense: !this.state.addExpense })
  }

  handleExpenseAdded = expense => {
    axios.post(backendUrl + 'expenses/new', expense)
      .then(res => {
        this.setState({
          expenses: [...this.state.expenses, res.data],
          addExpense: !this.state.addExpense
        })
        this.props.handleAddedExpense(res.data)
      })
  }

  handleExpenseUpdated = (updatedExpense, expenseIndex) => {
    this.setState({ activeExpense: {} }, () => {
      axios.post(backendUrl + 'expenses/edit', updatedExpense)
        .then(res => {
          const expenses = this.state.expenses
          expenses[expenseIndex] = res.data
          this.props.handleUpdatedExpense(expenses)
        })
    })
  }

  handleExpenseDelete = (expense, expenseIndex) => {
    const expenseId = expense._id
    axios.delete(backendUrl + 'expenses/delete', { params: { expenseId } })
      .then(res => {
        if (res.data === 'Expense deleted') {
          const expenses = this.state.expenses
          expenses.splice(expenseIndex, 1)
          this.setState({ expenses, activeExpense: {} })
          this.props.handleDeletedExpense(expenses)
        } else {
          window.alert('Expense could not be deleted')
        }
      })
  }

  render() {
    return (
      <div id='expenses-list' className='roboto'>
        {
          this.state.expenses.map((expense, i) => (
            <div key={i} className='expense-container' onClick={() => this.handleExpenseSelect(expense, i)}>
              <p style={{ width: '50%', textAlign: 'center', borderRight: '1px solid lightgray' }}>{expense.desc}</p>
              <p style={{ width: '50%' }}>{getAmount(expense.amount)}</p>
            </div>
          ))
        }
        {
          this.state.addExpense
            ?
            <AddExpense
              username={this.state.username}
              handleExpenseAdded={this.handleExpenseAdded}
              close={() => this.setState({ addExpense: false })}
            />
            :
            <div className='add-expense' onClick={this.handleAddExpense}>
              <p>+</p>
            </div>
        }
        <div>
          <Expense
            expense={this.state.activeExpense}
            expenseIndex={this.state.activeExpenseIndex}
            handleExpenseClosed={this.handleExpenseClosed}
            handleExpenseDelete={this.handleExpenseDelete}
            handleExpenseUpdated={this.handleExpenseUpdated}
          />
        </div>
        <div style={{ width: '9em', margin: '2em auto' }}>
          <Button addClass='button-1 font125 mt' clicked={this.props.handleBack} text='Back' />
        </div>
      </div>
    )
  }
}
